module.exports = __webpack_public_path__ + "static/media/pigeon-eating-saag.06cc49cd.gif";